import Lenis from 'lenis';

let lenis = null;

export function getLenis() {
  return lenis;
}

export default function setSmoothScroll() {
  // Touch devices already scroll natively with their own inertia, and
  // fighting that with Lenis is what caused the wheel/drag conflicts over
  // Swiper sliders — only run Lenis where a precise pointer (mouse/trackpad)
  // is available.
  if (!window.matchMedia('(pointer: fine)').matches) return null;

  lenis = new Lenis({
    autoRaf: true,
  });

  return lenis;
}
